import { Stack } from "@mui/material";
import { LargeContentBox, PageTitle } from "../../components/common";
import { isMobile } from "react-device-detect";
import { useNavigate } from "react-router-dom";
import { Form } from "./components/form";
import { ScreenMobile } from "../../components/common/ScreenMobile";
import { PageHeader } from "@/components/common/PageHeader";
import { FamilyRestroom } from "@mui/icons-material";

interface MyfamilyProps {
  /** Quando informado, o ScreenMobile é controlado pelo pai (ex.: JourneyCards). */
  open?: boolean;
  onClose?: () => void;
}

export function Myfamily({ open, onClose }: MyfamilyProps) {
  const navigate = useNavigate();

  const handleClose = () => {
    if (onClose) {
      onClose();
      return;
    }
    // Rota /myfamily (barra inferior): fecha voltando ao dashboard.
    navigate("/home");
  };

  return isMobile ? (
    <ScreenMobile
      title="Minha família"
      open={open ?? true}
      onClose={handleClose}
    >
      <Form />
    </ScreenMobile>
  ) : (
    <LargeContentBox>
      <Stack sx={{ width: "100%" }} spacing={2}>
        <PageHeader
          title="Minha Família"
          icon={FamilyRestroom}
          description="Cadastre o menor de idade ou dependente e acompanhe resultados de exames, agende consultas e muito mais."
        />
        <Form />
      </Stack>
    </LargeContentBox>
  );
}
